import { camelizeKeys, decamelizeKeys } from 'humps';

type DataTypes = Record<string, unknown> | Record<string, unknown>[];

const toFrontFormat = (data: DataTypes): DataTypes => camelizeKeys(data);

const toBackFormat = (data: DataTypes): DataTypes => decamelizeKeys(data);

const CaseAdapter = {
  toFrontFormat,
  toBackFormat,
};

export { CaseAdapter };
